/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React from 'react';
import { array } from 'prop-types';
import { NavLink } from 'react-router-dom';
import reactStringReplace from 'react-string-replace';

import { createUrl } from 'utils/urlHelper';

import AddIcon from 'gfx/vector/add-icon.svg';
import JobIcon from 'gfx/vector/notifications/job-icon.svg';
import InboxIcon from 'gfx/vector/notifications/inbox-icon.svg';
import ProfileIcon from 'gfx/vector/notifications/profile-icon.svg';
import PortfolioIcon from 'gfx/vector/notifications/portfolio-icon.svg';
import PaymentIcon from 'gfx/vector/notifications/payment-icon.svg';
import DisussionIcon from 'gfx/vector/notifications/discussion-icon.svg';
import CompanyIcon from 'gfx/vector/notifications/company-icon.svg';

import styles from './notifications.scss';

const icons = {
  INVITE: <AddIcon />,
  INBOX: <InboxIcon />,
  JOB: <JobIcon />,
  NEWJOB: <JobIcon />,
  PAYMENT: <PaymentIcon />,
  PROFILE: <ProfileIcon />,
  COMPANY: <CompanyIcon />,
  PORTFOLIO: <PortfolioIcon />,
  DISCUSSION: <DisussionIcon />,
  ADMIN: <PortfolioIcon />,
};

const renderLink = (type, job_id = '', discussion_id = '') => {
  switch (type) {
    case 'INVITE':
      return <NavLink to={createUrl('invite')} className={styles.link} />;

    case 'JOB':
      return <NavLink to={createUrl('job', job_id)} className={styles.link} />;

    case 'NEWJOB':
      return <NavLink to={createUrl('createJob')} className={styles.link} />;

    case 'INBOX':
      return <NavLink to={createUrl('inbox')} className={styles.link} />;

    case 'DISCUSSION':
      return (
        <NavLink
          to={createUrl('message', discussion_id)}
          className={styles.link}
        />
      );

    case 'PAYMENT':
      return <NavLink to={createUrl('payments')} className={styles.link} />;

    case 'ADMIN':
      return <NavLink to={createUrl('pageAdmin')} className={styles.link} />;

    case 'PROFILE':
      return <NavLink to={createUrl('editProfile')} className={styles.link} />;

    case 'COMPANY':
      return <NavLink to={createUrl('editCompany')} className={styles.link} />;

    case 'PORTFOLIO':
      return (
        <NavLink to={createUrl('editPortfolio')} className={styles.link} />
      );

    default:
      return null;
  }
};

/**
 * This is the Notifications component.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 */
export const Notifications = ({ items }) => {
  // The admin notification is essentially a link to an additonal admin page
  // Since the link is added to the menu the notification is redundant and somewhat confusing
  // and therefore filtered out from the notifcations.
  const filteredItems = items.filter(item => item.type !== 'ADMIN');

  return (
    <section className={styles.wrapper}>
      {filteredItems.map(({ type, description, job_id, discussion_id }, i) => (
        <article className={styles.item} key={i}>
          <span className={styles.icon}>{icons[type]}</span>
          <div className={styles.description}>
            {reactStringReplace(description, /\[(.*?)\]/, (match, i) => (
              <span key={i}>{match}</span>
            ))}
          </div>
          {renderLink(type, job_id, discussion_id)}
        </article>
      ))}
    </section>
  );
};

Notifications.propTypes = {
  items: array.isRequired,
};

export default Notifications;
